import * as MuiIcons from '@mui/icons-material'
import { FeatureListItem, FeatureListSlice } from './UpsellModalPrismicDocument'
import { Icon, List, ListItem, ListItemIcon, ListItemText } from '@mui/material'
import { PrismicRichText, SliceComponentProps } from '@prismicio/react'
import { Stack, Typography } from '@dtx-company/design-system/src'
import { serializer } from '@app/upsell-modals/src/PrismicUpsellModalContent/Serializer'
import React, { useId } from 'react'

const _FeatureListItem = ({ mui_icon_component, text }: FeatureListItem): JSX.Element => {
  const CustomIcon = MuiIcons[mui_icon_component as keyof typeof MuiIcons]
  const hasIcon = Boolean(mui_icon_component) && Boolean(CustomIcon)
  return (
    <ListItem disableGutters disablePadding alignItems="flex-start">
      <ListItemIcon sx={{ minWidth: 40, margin: 0 }}>
        {hasIcon ? <Icon component={CustomIcon} /> : <></>}
      </ListItemIcon>
      <ListItemText primaryTypographyProps={{ variant: 'bodySmall' }} sx={{ m: 0 }}>
        {<PrismicRichText field={text} components={serializer} />}
      </ListItemText>
    </ListItem>
  )
}

export const UpsellModalFeatureListSlice = ({
  slice
}: SliceComponentProps<FeatureListSlice>): JSX.Element => {
  const {
    items,
    primary: { feature_list_header }
  } = slice
  const id = useId()
  const headerId = feature_list_header ? id : undefined
  return (
    <Stack gap={4}>
      {feature_list_header && (
        <Typography id={headerId} variant="labelMedium">
          {feature_list_header}
        </Typography>
      )}
      {items.length > 0 && (
        <List
          aria-labelledby={headerId}
          disablePadding
          sx={{ display: 'flex', flexDirection: 'column', gap: 4 }}
        >
          {items.map((item, index) => (
            <_FeatureListItem key={index} {...item} />
          ))}
        </List>
      )}
    </Stack>
  )
}
